import { NgModule } from '@angular/core';
import { panelbarRouting, appRoutingProviders } from '../app-routing.module';

/**
 * Common Modules
 */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@progress/kendo-angular-layout';

/**
 * Kendo UI Modules
 */
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { TabStripModule, PanelBarModule } from '@progress/kendo-angular-layout';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

/**
 * CGP Modules
 */
import { CgpUserProfileDialogModule } from './cgp-user-profile-dialog/cgp-user-profile-dialog.module';
import { CgpAppBarModule } from './cgp-app-bar/cgp-app-bar.module';
import { CgpSidenavComponent } from './cgp-sidenav/cgp-sidenav.component';
import { CgpAlertDialogModule } from './cgp-alert-dialog/cgp-alert-dialog.module';
import { CgpConfirmationDialogModule } from './cgp-confirmation-dialog/cgp-confirmation-dialog.module';
import { CgpBreadcrumbsModule } from './cgp-breadcrumbs/cgp-breadcrumbs.module';
import { CgpSnackbarModule } from './cgp-snackbar/cgp-snackbar.module';
import { CgpIdleModule } from './cgp-idle/cgp-idle.module';

import { CgpSidenavService } from './cgp-sidenav/cgp-sidenav.service';

import { CgpGridModule } from './cgp-grid/cgp-grid.module';
import { CgpFormDialogModule } from './cgp-form-dialog/cgp-form-dialog.module';
import { CgpTabbedFormDialogModule } from './cgp-tabbed-form-dialog/cgp-tabbed-form-dialog.module';
import { CgpPanelModule } from './cgp-panel/cgp-panel.module';

import { CgpFooterComponent } from './cgp-footer/cgp-footer.component';

/**
 * Common Pipes
 */

import { PipesModule } from './pipes/pipes.module';

/**
 * Services
 */
import { RouteValidationService } from "./route-validation.service";
import { CgpTreeviewService } from './cgp-treeview/cgp-treeview.service'

import { CgpTreeviewComponent } from './cgp-treeview/cgp-treeview.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    LayoutModule,
    CgpAlertDialogModule,
    CgpConfirmationDialogModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpIdleModule,
    CgpFormDialogModule,
    PipesModule,
    CgpGridModule,
    CommonModule,
    RouterModule,
    PanelBarModule,
    panelbarRouting,
  ],
  declarations: [
    CgpSidenavComponent,
    CgpFooterComponent,
    CgpTreeviewComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SwitchModule,
    NumericTextBoxModule,
    AutoCompleteModule,
    MultiSelectModule,
    ComboBoxModule,
    DropDownListModule,
    DialogModule,
    ButtonsModule,
    ButtonGroupModule,
    GridModule,
    TabStripModule,
    PanelBarModule,
    ExcelModule,
    DateInputsModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpIdleModule,

    CgpFormDialogModule,
    CgpGridModule,
    CgpTabbedFormDialogModule,
    CgpPanelModule,
    CgpUserProfileDialogModule,
    PipesModule,
    CgpTreeviewComponent,
    CgpSidenavComponent,
    CgpFooterComponent,
  ],

  providers: [
    CgpAlertDialogModule,
    CgpConfirmationDialogModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpSidenavComponent,
    CgpFooterComponent,
    CgpSidenavService,
    appRoutingProviders,
    RouteValidationService,
    CgpTreeviewService
  ],
})
export class SharedModule { }
